(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.TheoricLeveMaisCore = factory();
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var REGRAS = ['mais_barato_gratis', 'espelho'];
  function inteiro(valor, minimo, maximo) {
    return Number.isSafeInteger(valor) && valor >= minimo && valor <= maximo;
  }
  function instante(valor) {
    if (typeof valor !== 'string') return NaN;
    var partes = /^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d{1,9})?(?:Z|([+-])(\d{2}):?(\d{2}))$/.exec(valor);
    if (!partes || Number(partes[2]) > 23 || Number(partes[3]) > 59 || Number(partes[4]) > 59 ||
        Number(partes[6] || 0) > 14 || Number(partes[7] || 0) > 59 ||
        (Number(partes[6]) === 14 && Number(partes[7]) !== 0)) return NaN;
    var dia = Date.parse(partes[1] + 'T00:00:00Z');
    if (!Number.isFinite(dia) || new Date(dia).toISOString().slice(0, 10) !== partes[1]) return NaN;
    return Date.parse(valor);
  }
  function validar(promo) {
    if (!promo || !promo.id || REGRAS.indexOf(promo.regra) < 0) return 'Regra desconhecida';
    var inicio = instante(promo.inicio);
    var fim = instante(promo.fim);
    if (!Number.isFinite(inicio) || !Number.isFinite(fim) || inicio >= fim) return 'Vigencia invalida';
    if (promo.regra === 'mais_barato_gratis' &&
        (!inteiro(Number(promo.grupo), 2, 100) ||
         !inteiro(Number(promo.gratis_por_grupo), 1, Number(promo.grupo) - 1))) return 'Grupo invalido';
    if (promo.regra === 'espelho' && !inteiro(Number(promo.multiplicador), 1, 10)) return 'Multiplicador invalido';
    return '';
  }
  function selecionar(promocoes, pedidoEm) {
    var avisos = [];
    var agora = instante(pedidoEm);
    if (!Number.isFinite(agora)) return { promo: null, avisos: ['pedidoEm invalido: informe ISO com fuso'] };
    var ativas = (promocoes || []).filter(function (p) {
      if (!p || REGRAS.indexOf(p.regra) < 0 || p.ativo === false || p.ativo === 'false' || p.status === 'DRAFT') return false;
      var erro = validar(p);
      if (erro) { avisos.push(p.id + ': ' + erro); return false; }
      return agora >= instante(p.inicio) && agora < instante(p.fim);
    });
    var espelhos = ativas.filter(function (p) { return p.regra === 'espelho'; });
    var candidatas = espelhos.length ? espelhos : ativas;
    if (candidatas.length > 1) {
      avisos.push('PROMO_CONFLITO: mais de uma campanha da mesma regra vigente');
      return { promo: null, avisos: avisos };
    }
    return { promo: candidatas[0] || null, avisos: avisos };
  }
  function planejar(linhas, promo) {
    var erro = validar(promo);
    if (erro) throw new Error(erro);
    var quantidade = 0;
    var elegiveis = [];
    linhas.forEach(function (l, i) {
      if (l.elegivel === false || l.kit === true) return;
      if (!inteiro(l.quantidade, 1, 10000) || !inteiro(l.valorCentavos, 1, 100000000)) throw new Error('Linha promocional invalida: ' + i);
      quantidade += l.quantidade;
      elegiveis.push({ indice: i, quantidade: l.quantidade, valorCentavos: l.valorCentavos });
    });
    if (quantidade > 10000) throw new Error('Limite de 10000 unidades excedido');
    var gratis = [];
    var valor = 0;
    var alvo = promo.regra === 'espelho'
      ? quantidade * Number(promo.multiplicador)
      : Math.floor(quantidade / Number(promo.grupo)) * Number(promo.gratis_por_grupo);
    var restante = alvo;
    elegiveis.sort(function (a, b) { return a.valorCentavos - b.valorCentavos || a.indice - b.indice; });
    elegiveis.forEach(function (l) {
      var q = promo.regra === 'espelho' ? l.quantidade * Number(promo.multiplicador) : Math.min(l.quantidade, restante);
      if (!q) return;
      gratis.push({ indice: l.indice, quantidade: q, valorCentavos: l.valorCentavos });
      valor += q * l.valorCentavos;
      restante -= q;
    });
    return {
      quantidade: quantidade, unidades: alvo, valorCentavos: valor, gratis: gratis,
      faltam: !quantidade || promo.regra === 'espelho' ? 0 : Number(promo.grupo) - quantidade % Number(promo.grupo)
    };
  }
  return { validar: validar, selecionar: selecionar, planejar: planejar };
});
